"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.filter.group': '按组筛选',
    'knowledge.filter.all_groups': '所有组',
    'knowledge.filter.assigned_only': '仅显示已分配的知识',
    'knowledge.filter.by_avatar': '按头像筛选',
    'knowledge.filter.all_avatars': '所有头像',
};
